import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SuccessDialog } from 'components/Shared/Dialogs/SuccessDialog'
import { useErrorHandling } from 'context/errorHandling'
import { createInsurancePolicy } from 'services/InsurancePolicyService'
import { InsurancePolicyForm } from 'components/Contractors/InsurancePolicy/Form/InsurancePolicyForm'
import { INITIAL_VALUES } from 'components/Contractors/InsurancePolicy/Form/form'
import { useNavigatePrevent } from 'context/navigatePrevent';

export function CreateInsurancePolicyForm (props) {
  const contractorId = props.match.params.contractorId
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const { setNavigationUnlocked } = useNavigatePrevent()

  const { t } = useTranslation()
  const { handleError } = useErrorHandling()

  const handleSubmit = (values, onSuccess) => {
    setLoading(true)
    createInsurancePolicy({ contractorId, ...values })
      .then(createdInsurancePolicy => onSuccess(createdInsurancePolicy)
        .then(() => setSuccessDialogOpen(true))
        .catch(handleError)
      )
      .catch(error => handleError(error))
      .then(() => setLoading(false))
  }


  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push(`/contractors/details/${contractorId}`))
  }

  return (
    <>
      <InsurancePolicyForm
        onSubmit={handleSubmit}
        initialValues={INITIAL_VALUES}
        initialPolicyFiles={[]}
        initialConfirmationFiles={[]}
        title={t('insurancePolicy.form.create.title')}
        loading={loading}
      />
      <SuccessDialog
        content='insurancePolicy.form.create.successMessage'
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
    </>
  )
}
